var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.644,
    height: 67.644,
    viewBox: "0 0 67.644 67.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .alert-a,.alert-b{fill:none;stroke:#3eb3a9;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.alert-a{stroke-dasharray:116\n      29;}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.082 2.082)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "alert-a",
    d: "M45.727,22.863A22.863,22.863,0,1,1,22.863,0,22.863,22.863,0,0,1,45.727,22.863Z",
    transform: "translate(63.479 25.57) rotate(124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alert-b",
    d: "M18,12V31.184",
    transform: "translate(13.74 6.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alert-b",
    d: "M19.146,25.146h0",
    transform: "translate(12.594 23.77)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.4def6b2cb58b7e116b6e153764ea5ebf.svg";
export { ForwardRef as ReactComponent };